export const sanitizeHref = (raw: string): string => {
  if (!raw) return '#';
  const trimmed = raw.trim();
  if (/^https?:\/\//i.test(trimmed)) return trimmed;
  if (/^[a-z][a-z0-9+.-]*:/i.test(trimmed)) return '#';
  return `https://${trimmed}`;
};

export const normalizeHttpUrl = (raw: string): string => {
  const value = raw.trim();
  if (!value) return '';
  if (/^https?:\/\//i.test(value)) return value;
  return `https://${value}`;
};

export const isValidHttpUrl = (raw: string): boolean => {
  const value = raw.trim();
  if (!value) return true;

  if (/\s/.test(value)) return false;

  const tryParse = (candidate: string) => {
    const url = new URL(candidate);
    const host = url.hostname;
    const labels = host.split('.');
    return (
      (url.protocol === 'http:' || url.protocol === 'https:') &&
      Boolean(host) &&
      !host.startsWith('.') &&
      !host.endsWith('.') &&
      !host.includes('..') &&
      labels.length >= 2 &&
      labels.every(Boolean)
    );
  };

  try {
    if (/^https?:\/\//i.test(value)) return tryParse(value);
    if (/^[a-z][a-z0-9+.-]*:\/\//i.test(value)) return false;
    return tryParse(`https://${value}`);
  } catch {
    return false;
  }
};
